import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import CampoFormulario from "../../components/CampoFormulario";
import { CAMPOS_LOGISTICA } from "../../model/campos";

/**
 * Paso Reserva: cuando y donde. Los campos salen de CAMPOS_LOGISTICA, en dos
 * columnas: fecha y celular, bloque y salon, hora de inicio y de fin. Arriba,
 * si biblioteca lo configuro, el horario de atencion: la actividad debe caer
 * dentro de el.
 */
const PasoReserva = ({ valores, errores, onChange, catalogos, ayudaDe, horarioAtencion }) => (
  <Grid container spacing={3}>
    {horarioAtencion && (
      <Grid item xs={12}>
        <Alert severity="info">Biblioteca atiende {horarioAtencion}.</Alert>
      </Grid>
    )}
    {CAMPOS_LOGISTICA.map((campo) => (
      <Grid item xs={12} sm={12} md={6} lg={6} key={campo.name}>
        <CampoFormulario
          campo={campo}
          valor={valores[campo.name]}
          error={errores[campo.name]}
          onChange={onChange}
          opciones={catalogos[campo.catalogo]}
          ayuda={ayudaDe(campo.name)}
        />
      </Grid>
    ))}
  </Grid>
);

PasoReserva.propTypes = {
  valores: PropTypes.object.isRequired,
  errores: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  catalogos: PropTypes.object.isRequired,
  // Recibe el nombre del campo y devuelve su texto de ayuda, o "".
  ayudaDe: PropTypes.func.isRequired,
  // "lunes a viernes de 06:00 a 21:00", o "" si no hay horario.
  horarioAtencion: PropTypes.string,
};

PasoReserva.defaultProps = { horarioAtencion: "" };

export default PasoReserva;
